var _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFingerPoint64Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H64V64H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 20V29.9727C20.7734 27.8125 18.668 24.1602 18.668 20C18.668 13.3594 24.0273 8 30.668 8C37.3086 8 42.668 13.3594 42.668 20C42.668 24.1602 40.5625 27.8125 37.3359 29.9727V20C37.3359 16.3203 34.3477 13.332 30.668 13.332C26.9883 13.332 24 16.3203 24 20ZM38.1328 36.293L50.2422 42.3203C51.6562 42.9062 52.668 44.3477 52.668 46C52.668 46.1602 52.6406 46.3477 52.6133 46.5352L50.6133 60.5859C50.3203 62.5352 48.7734 64 46.7734 64H28.668C27.5742 64 26.5625 63.5469 25.8398 62.8281L12.668 49.6523L14.7734 47.5195C15.3086 46.9883 16.0547 46.6406 16.8828 46.6406C17.0469 46.6406 17.1836 46.6641 17.3242 46.6875L17.5195 46.7188L26.668 48.6406V20C26.668 17.7852 28.4531 16 30.668 16C32.8828 16 34.668 17.7852 34.668 20V36H36.6953C37.2031 36 37.6797 36.1055 38.1328 36.293Z",
    fill: "url(#paint0_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 32.668,
    y1: 92,
    x2: 85.6409,
    y2: 54.1622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0033AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0033AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFingerPoint64Px);
export default __webpack_public_path__ + "static/media/ic_finger_point_64px.9e79080f1b9c1e55b65a2a3f3835dc14.svg";
export { ForwardRef as ReactComponent };